import FinancialUserInfo from '../../../commons/financial-user-info';
import withTracker from '../../../commons/with-tracker';

export default withTracker(FinancialUserInfo);
